import { SWITCHBOARD, findEntry } from "./switchboard";

/**
 * Where a locked account's person without billing rights lands: the new locked-account page (/help/contact)
 * once its switchboard line is flipped, today's /account-suspended while it is legacy.
 */
export const lockedLandingPath = (): string =>
  findEntry("/help/contact", SWITCHBOARD)?.entry.mode === "next" ? "/help/contact" : "/account-suspended";
